"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeFilter = exports.TRANSLATIONS = exports.OPERATION = exports.PROCESS = exports.INTERNAL = exports.POSITION = exports.NAME = exports.DESCRIPTION = exports.ACTIVE = exports.SUBSCRIPTION_DEFINTION = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var SUBSCRIPTION_DEFINTION = 'SubscriptionDefinition';
exports.SUBSCRIPTION_DEFINTION = SUBSCRIPTION_DEFINTION;
var ACTIVE = 'active';
exports.ACTIVE = ACTIVE;
var DESCRIPTION = 'description';
exports.DESCRIPTION = DESCRIPTION;
var NAME = 'name';
exports.NAME = NAME;
var POSITION = 'position';
exports.POSITION = POSITION;
var INTERNAL = 'internal';
exports.INTERNAL = INTERNAL;
var PROCESS = 'process';
exports.PROCESS = PROCESS;
var OPERATION = 'operation';
exports.OPERATION = OPERATION;
var TRANSLATIONS = 'translations';
exports.TRANSLATIONS = TRANSLATIONS;
var TypeFilter = (0, _keyMirror.default)({
  ACTIVE: null,
  ALL: null,
  INACTIVE: null
});
exports.TypeFilter = TypeFilter;